import ImagePreview from "./image";
import VideoPreview from "./video";
import TextPreview from "./text";
import PdfPreview from "./pdf";
import NonPlayableVideo from "./nonPlayableVideo";
import TiffImagePreview from "./tiffImage";

const componentMap = new Map([
  ["video/mp4", VideoPreview],
  ["image/jpeg", ImagePreview],
  ["image/png", ImagePreview],
  ["image/tiff", TiffImagePreview],
  ["text/plain", TextPreview],
  ["application/json", TextPreview],
  ["application/pdf", PdfPreview],
  ["video/quicktime", NonPlayableVideo],
  ["video/mpeg", NonPlayableVideo],
  ["video/x-msvideo", NonPlayableVideo],
]);

export const PREVIEWABLE_MIMETYPES = new Set(componentMap.keys());

export default function FilePreview({ type, src, ...props }: { type: string; src: string; [key: string]: any }) {
  const PreviewComponent = componentMap.get(type);
  if (!PreviewComponent) {
    return <></>; // TODO - preview unavailable
  }
  return <PreviewComponent type={type} src={src} {...props} />;
}
